import { Link } from "react-router-dom";

export const CookieBanner = ({ onAccept, onReject }) => (
    <div
        className="fixed z-50 bottom-2 inset-x-2 sm:inset-x-auto sm:right-4 sm:bottom-4 sm:max-w-md bg-superficie border border-bordo rounded-xl p-5 shadow-2xl"
        role="dialog"
        aria-label="Preferenze cookie"
        data-testid="cookie-banner"
    >
        <p className="text-sm text-avorio/85">
            Usiamo solo cookie tecnici per ricordare le tue preferenze. Servizi di terze parti (come la mappa di
            Google) si caricano soltanto dopo il tuo consenso.
        </p>
        <p className="mt-2 text-xs">
            <Link to="/cookie" className="underline text-ambra" data-testid="cookie-banner-policy-link">
                Cookie policy
            </Link>
        </p>
        <div className="mt-4 flex gap-3">
            <button className="btn btn-amber flex-1" onClick={onAccept} data-testid="cookie-accept-btn">
                Accetta
            </button>
            <button className="btn btn-outline flex-1" onClick={onReject} data-testid="cookie-reject-btn">
                Rifiuta
            </button>
        </div>
    </div>
);